var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e16) { throw _e16; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e17) { didErr = true; err = _e17; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function () {
  var e = {
      945: function _(e, t, n) {
        e.exports = n(79)("./src/clipboard.js");
      },
      704: function _(e, t, n) {
        e.exports = n(79)("./src/core.js");
      },
      492: function _(e, t, n) {
        e.exports = n(79)("./src/engine.js");
      },
      79: function _(e) {
        "use strict";

        e.exports = CKEditor5.dll;
      }
    },
    t = {};
  function n(r) {
    var s = t[r];
    if (void 0 !== s) return s.exports;
    var i = t[r] = {
      exports: {}
    };
    return e[r](i, i.exports, n), i.exports;
  }
  n.d = function (e, t) {
    for (var r in t) {
      n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  (function () {
    "use strict";

    n.r(r), n.d(r, {
      PasteFromOffice: function PasteFromOffice() {
        return b;
      }
    });
    var e = n(704),
      t = n(945),
      s = n(492);
    function i(e, t) {
      if (!e.childCount) return;
      var n = new s.UpcastWriter(e.document),
        r = function (e, t) {
          var n = t.createRangeIn(e),
            r = new s.Matcher({
              name: /^p|h\d+$/,
              styles: {
                "mso-list": /.*/
              }
            }),
            i = [];
          var _iterator = _createForOfIteratorHelper(n),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _e = _step.value;
              if ("elementStart" === _e.type && r.match(_e.item)) {
                var _t = a(_e.item);
                i.push({
                  element: _e.item,
                  id: _t.id,
                  order: _t.order,
                  indent: _t.indent
                });
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return i;
        }(e, n);
      if (!r.length) return;
      var i = null,
        l = 1;
      r.forEach(function (e, a) {
        var u = function (e, t) {
            if (!e) return !0;
            if (e.id !== t.id) return t.indent - e.indent != 1;
            var n = t.element.previousSibling;
            if (!n) return !0;
            return r = n, !(r.is("element", "ol") || r.is("element", "ul"));
            var r;
          }(r[a - 1], e),
          f = u ? null : r[a - 1],
          p = (m = e, (d = f) ? m.indent - d.indent : m.indent - 1);
        var d, m;
        if (u && (i = null, l = 1), !i || 0 !== p) {
          var _r = function (e, t) {
            var n = new RegExp("@list l".concat(e.id, ":level").concat(e.indent, "\\s*({[^}]*)"), "gi"),
              r = /mso-level-number-format:([^;]{0,100});/gi,
              s = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
              i = n.exec(t);
            var c = "decimal",
              a = "ol",
              l = null;
            if (i && i[1]) {
              var _t2 = r.exec(i[1]);
              if (_t2 && _t2[1] && (c = _t2[1].trim(), a = "bullet" !== c && "image" !== c ? "ol" : "ul"), "bullet" === c) {
                var _t3 = function (e) {
                  var t = function (e) {
                    if (e.getChild(0).is("$text")) return null;
                    var _iterator2 = _createForOfIteratorHelper(e.getChildren()),
                      _step2;
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var _t4 = _step2.value;
                        if (!_t4.is("element", "span")) continue;
                        var _e2 = _t4.getChild(0);
                        return _e2.is("$text") ? _e2 : _e2.getChild(0);
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }(e);
                  if (!t) return null;
                  var n = t._data;
                  if ("o" === n) return "circle";
                  if ("·" === n) return "disc";
                  if ("§" === n) return "square";
                  return null;
                }(e.element);
                _t3 && (c = _t3);
              } else {
                var _e3 = s.exec(i[1]);
                _e3 && _e3[1] && (l = parseInt(_e3[1]));
              }
            }
            return {
              type: a,
              startIndex: l,
              style: o(c)
            };
          }(e, t);
          if (i) {
            if (e.indent > l) {
              var _e4 = i.getChild(i.childCount - 1),
                _t5 = _e4.getChild(_e4.childCount - 1);
              i = c(_r, _t5, n), l += 1;
            } else if (e.indent < l) {
              var _t6 = l - e.indent;
              i = function (e, t) {
                var n = e.getAncestors({
                  parentFirst: !0
                });
                var r = null,
                  s = 0;
                var _iterator3 = _createForOfIteratorHelper(n),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _e5 = _step3.value;
                    if ("ul" !== _e5.name && "ol" !== _e5.name || s++, s === t) {
                      r = _e5;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                return r;
              }(i, _t6), l = parseInt(e.indent);
            }
          } else i = c(_r, e.element, n);
          e.indent <= l && (i.is("element", _r.type) || (i = n.rename(_r.type, i)));
        }
        var g = function (e, t) {
          return function (e, t) {
            var n = new s.Matcher({
                name: "span",
                styles: {
                  "mso-list": "Ignore"
                }
              }),
              r = t.createRangeIn(e);
            var _iterator4 = _createForOfIteratorHelper(r),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _e6 = _step4.value;
                "elementStart" === _e6.type && n.match(_e6.item) && t.remove(_e6.item);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }(e, t), t.rename("li", e);
        }(e.element, n);
        n.appendChild(g, i);
      });
    }
    function o(e) {
      if (e.startsWith("arabic-leading-zero")) return "decimal-leading-zero";
      switch (e) {
        case "alpha-upper":
          return "upper-alpha";
        case "alpha-lower":
          return "lower-alpha";
        case "roman-upper":
          return "upper-roman";
        case "roman-lower":
          return "lower-roman";
        case "circle":
        case "disc":
        case "square":
          return e;
        default:
          return null;
      }
    }
    function c(e, t, n) {
      var r = t.parent,
        s = n.createElement(e.type),
        i = r.getChildIndex(t) + 1;
      return n.insertChild(i, s, r), e.style && n.setStyle("list-style-type", e.style, s), e.startIndex && e.startIndex > 1 && n.setAttribute("start", e.startIndex, s), s;
    }
    function a(e) {
      var t = {},
        n = e.getStyle("mso-list");
      if (n) {
        var _e7 = n.match(/(^|\s{1,100})l(\d+)/i),
          _r2 = n.match(/\s{0,100}lfo(\d+)/i),
          _s = n.match(/\s{0,100}level(\d+)/i);
        _e7 && _r2 && _s && (t.id = _e7[2], t.order = _r2[1], t.indent = _s[1]);
      }
      return t;
    }
    var l = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
    var u = /*#__PURE__*/function () {
      function u(e) {
        _classCallCheck(this, u);
        this.document = e;
      }
      _createClass(u, [{
        key: "isActive",
        value: function isActive(e) {
          return l.test(e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var t = new s.UpcastWriter(this.document),
            n = e._parsedData.body;
          !function (e, t) {
            var _iterator5 = _createForOfIteratorHelper(e.getChildren()),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _n = _step5.value;
                if (_n.is("element", "b") && "normal" === _n.getStyle("font-weight")) {
                  var _r3 = e.getChildIndex(_n);
                  t.remove(_n), t.insertChild(_r3, _n.getChildren(), e);
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }(n, t), function (e, t) {
            var _iterator6 = _createForOfIteratorHelper(t.createRangeIn(e)),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _n2 = _step6.value;
                var _e8 = _n2.item;
                if (_e8.is("element", "li")) {
                  var _n3 = _e8.getChild(0);
                  _n3 && _n3.is("element", "p") && t.unwrapElement(_n3);
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }(n, t), e.content = n;
        }
      }]);
      return u;
    }();
    function f(e, t) {
      if (!e.childCount) return;
      var n = new s.UpcastWriter(),
        r = function (e, t) {
          var n = t.createRangeIn(e),
            r = new s.Matcher({
              name: /v:(.+)/
            }),
            i = [];
          var _iterator7 = _createForOfIteratorHelper(n),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _e9 = _step7.value;
              if ("elementStart" != _e9.type) continue;
              var _t7 = _e9.item,
                _n4 = _t7.previousSibling && _t7.previousSibling.name || null;
              r.match(_t7) && _t7.getAttribute("o:gfxdata") && "v:shapetype" !== _n4 && i.push(_e9.item.getAttribute("id"));
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
          return i;
        }(e, n);
      !function (e, t, n) {
        var r = n.createRangeIn(t),
          i = new s.Matcher({
            name: "img"
          }),
          o = [];
        var _iterator8 = _createForOfIteratorHelper(r),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _t8 = _step8.value;
            if (i.match(_t8.item)) {
              var _n5 = _t8.item,
                _r4 = _n5.getAttribute("v:shapes") ? _n5.getAttribute("v:shapes").split(" ") : [];
              _r4.length && _r4.every(function (t) {
                return e.indexOf(t) > -1;
              }) ? o.push(_n5) : _n5.getAttribute("src") || o.push(_n5);
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
        for (var _i = 0, _o = o; _i < _o.length; _i++) {
          var _e10 = _o[_i];
          n.remove(_e10);
        }
      }(r, e, n), function (e, t) {
        var n = t.createRangeIn(e),
          r = new s.Matcher({
            name: /v:(.+)/
          }),
          i = [];
        var _iterator9 = _createForOfIteratorHelper(n),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _e12 = _step9.value;
            "elementStart" == _e12.type && r.match(_e12.item) && i.push(_e12.item);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
        for (var _i3 = 0, _i2 = i; _i3 < _i2.length; _i3++) {
          var _e11 = _i2[_i3];
          t.remove(_e11);
        }
      }(e, n);
      var i = function (e, t) {
        var n = t.createRangeIn(e),
          r = new s.Matcher({
            name: "img"
          }),
          i = [];
        var _iterator10 = _createForOfIteratorHelper(n),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _e13 = _step10.value;
            r.match(_e13.item) && _e13.item.getAttribute("src").startsWith("file://") && i.push(_e13.item);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
        return i;
      }(e, n);
      i.length && function (e, t, n) {
        if (e.length === t.length) for (var _r5 = 0; _r5 < e.length; _r5++) {
          var _s2 = "data:".concat(t[_r5].type, ";base64,").concat(p(t[_r5].hex));
          n.setAttribute("src", _s2, e[_r5]);
        }
      }(i, function (e) {
        if (!e) return [];
        var t = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
          n = new RegExp("(?:(" + t.source + "))([\\da-fA-F\\s]+)\\}", "g"),
          r = e.match(n),
          s = [];
        if (r) {
          var _iterator11 = _createForOfIteratorHelper(r),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _e14 = _step11.value;
              var _n6 = !1;
              _e14.includes("\\pngblip") ? _n6 = "image/png" : _e14.includes("\\jpegblip") && (_n6 = "image/jpeg"), _n6 && s.push({
                hex: _e14.replace(t, "").replace(/[^\da-fA-F]/g, ""),
                type: _n6
              });
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        }
        return s;
      }(t), n);
    }
    function p(e) {
      return btoa(e.match(/\w{2}/g).map(function (e) {
        return String.fromCharCode(parseInt(e, 16));
      }).join(""));
    }
    var d = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
      m = /xmlns:o="urn:schemas-microsoft-com/i;
    var g = /*#__PURE__*/function () {
      function g(e) {
        _classCallCheck(this, g);
        this.document = e;
      }
      _createClass(g, [{
        key: "isActive",
        value: function isActive(e) {
          return d.test(e) || m.test(e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var _e$_parsedData = e._parsedData,
            t = _e$_parsedData.body,
            n = _e$_parsedData.stylesString;
          i(t, n), f(t, e.dataTransfer.getData("text/rtf")), e.content = t;
        }
      }]);
      return g;
    }();
    function h(e) {
      return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (e, t) {
        return 1 === t.length ? " " : Array(t.length + 1).join("  ").substr(0, t.length);
      });
    }
    function y(e, t) {
      var n = new DOMParser(),
        r = function (e) {
          return h(h(e)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function (e) {
          var t = "</body>",
            n = "</html>",
            r = e.indexOf(t);
          if (r < 0) return e;
          var s = e.indexOf(n, r + t.length);
          return e.substring(0, r + t.length) + (s >= 0 ? e.substring(s) : "");
        }(e = e.replace(/<!--\[if gte vml 1]>/g, ""))),
        i = n.parseFromString(r, "text/html");
      !function (e) {
        e.querySelectorAll("span[style*=spacerun]").forEach(function (e) {
          var t = e.innerText.length || 0;
          e.innerHTML = Array(t + 1).join("  ").substr(0, t);
        });
      }(i);
      var o = i.body.innerHTML,
        c = function (e, t) {
          var n = new s.ViewDocument(t),
            r = new s.DomConverter(n, {
              renderingMode: "data"
            }),
            i = e.createDocumentFragment(),
            o = e.body.childNodes;
          for (; o.length > 0;) {
            i.appendChild(o[0]);
          }
          return r.domToView(i, {
            skipComments: !0
          });
        }(i, t),
        a = function (e) {
          var t = [],
            n = [],
            r = Array.from(e.getElementsByTagName("style"));
          for (var _i4 = 0, _r6 = r; _i4 < _r6.length; _i4++) {
            var _e15 = _r6[_i4];
            _e15.sheet && _e15.sheet.cssRules && _e15.sheet.cssRules.length && (t.push(_e15.sheet), n.push(_e15.innerHTML));
          }
          return {
            styles: t,
            stylesString: n.join(" ")
          };
        }(i);
      return {
        body: c,
        bodyString: o,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }
    var b = /*#__PURE__*/function (_e$Plugin) {
      _inherits(b, _e$Plugin);
      function b() {
        _classCallCheck(this, b);
        return _possibleConstructorReturn(this, _getPrototypeOf(b).apply(this, arguments));
      }
      _createClass(b, [{
        key: "init",
        value: function init() {
          var e = this.editor,
            t = e.editing.view.document,
            n = [];
          n.push(new g(t)), n.push(new u(t)), e.plugins.get("ClipboardPipeline").on("inputTransformation", function (e, r) {
            if (r._isTransformedWithPasteFromOffice) return;
            var s = r.dataTransfer.getData("text/html"),
              i = n.find(function (e) {
                return e.isActive(s);
              });
            i && (r._parsedData = y(s, t.stylesProcessor), i.execute(r), r._isTransformedWithPasteFromOffice = !0);
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }, {
        key: "requires",
        get: function get() {
          return [t.ClipboardPipeline];
        }
      }]);
      return b;
    }(e.Plugin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).pasteFromOffice = r;
})();